/**
 * L2 — Visual Left / Text Right
 * Left 55%: primary image/video
 * Right 45%: headline + subheadline on dark panel
 */
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { SceneProps } from '../../types';
import {
  SceneContainer, Visual, HeadlineText, SubheadlineText,
  GlobalOverlays, AccentBar,
} from './shared';

export const L2_VisualLeftTextRight: React.FC<SceneProps> = (props) => {
  const { headline, subheadline, assets, colorPalette, headlineFont, subheadlineFont } = props;
  const primary = assets.primary ?? assets.video;

  return (
    <SceneContainer bg={colorPalette.background}>
      <AbsoluteFill style={{ display: 'flex', flexDirection: 'row' }}>

        {/* Left: visual */}
        <div style={{ width: '55%', height: '100%', overflow: 'hidden', position: 'relative' }}>
          <Visual asset={primary} kenBurns kenBurnsDirection="out" layerKey="primaryMedia" />

          {/* Right-edge gradient for smooth blend */}
          <div style={{
            position: 'absolute', top: 0, right: 0, width: 80, height: '100%',
            background: `linear-gradient(to right, transparent, ${colorPalette.background})`,
          }} />
        </div>

        {/* Right: text panel */}
        <div style={{
          width: '45%', height: '100%',
          background: colorPalette.background,
          display: 'flex', flexDirection: 'column',
          justifyContent: 'center',
          padding: '60px 60px 100px 40px',
          boxSizing: 'border-box',
        }}>
          {/* Category / accent line */}
          <AccentBar color={colorPalette.accent} style={{ marginBottom: 20, width: 60 }} />

          <HeadlineText
            text={headline}
            font={{ ...headlineFont, fontSize: Math.min(headlineFont.fontSize, 48) }}
            delay={6}
            layerKey="headline"
          />

          {subheadline && (
            <SubheadlineText
              text={subheadline}
              font={subheadlineFont}
              delay={18}
              style={{ marginTop: 16 }}
              layerKey="subheadline"
            />
          )}

          {/* Decorative bottom accent */}
          <div style={{
            marginTop: 28,
            width: 40, height: 3,
            background: colorPalette.accent,
            borderRadius: 2,
            opacity: 0.6,
          }} />
        </div>
      </AbsoluteFill>

      <GlobalOverlays props={props} />
    </SceneContainer>
  );
};
